import * as React from "react";
import { useHistory } from "react-router";

import { DiagnosisCompatibilityAgentsStepChips } from "@/components/diagnosis/DiagnosisCompatibilityAgentsStepChips";
import { usePlannerIntroductionEntrance } from "@/hooks/usePlannerIntroductionEntrance";
import { PlannerIntroductionLayout } from "@/layouts/PlannerIntroductionLayout";

import { CertifiedPlannerIntroduction } from "./components/CertifiedPlannerIntroduction";

export const DiagnosisCompatibilityAgentsCertifiedPage: React.FC = () => {
  const history = useHistory();
  const animate = usePlannerIntroductionEntrance("certified");
  return (
    <PlannerIntroductionLayout phaseTags={<DiagnosisCompatibilityAgentsStepChips />}>
      <CertifiedPlannerIntroduction animate={animate} onNext={() => history.push("/diagnosis_compatibility_agents/result")} />
    </PlannerIntroductionLayout>
  );
};
